import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Input, Label } from '@treams/treams-ui';

import BulkModal from './BulkModal';

export default function BulkUpdateActivationDateModal(props: {
	users: graphql.User[];
	onDismiss: () => void;
}) {
	const { t } = useTranslation();

	const [updateActivationDate] = graphql.useUpdateUserActivationDateMutation();

	const [startDate, setStartDate] = useState(new Date());

	return (
		<BulkModal
			name="bulkUpdateActivationDate"
			users={props.users}
			onDismiss={props.onDismiss}
			apply={async (user) => {
				await updateActivationDate({
					variables: {
						input: {
							userID: user.id,
							activatedAt: startDate,
						},
					},
				});
			}}
		>
			<Label mb={2}>{t('employees.bulkUpdateActivationDate.startDate.label')}</Label>
			<Flex>
				<Input.DatePicker
					value={startDate}
					onChange={(startDate) => setStartDate(startDate ?? new Date())}
				/>
			</Flex>
		</BulkModal>
	);
}
